import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import setting from "../../config/setting";
import HeatMap from "react-heatmap-grid";
import ResidualMark from '../SharedComponents/ResidualMark'
import TargetMark from '../SharedComponents/TargetMark'
import GrossMark from '../SharedComponents/GrossMark'
import 'chartjs-plugin-datalabels';


const xLabels = ['1', '2', '3', '4', '5'];

const yLabels = ['5', '4', '3', '2', '1'];


class CustomizedHeatMap extends Component {


    render() {
        let rrdata = this.props.rrdata
        let positionList = []
        return (
            <CardContent style={{padding:'0px', margin:'auto', width:'fit-content', position:'relative'}}>
                {rrdata == null ? null :
                    rrdata.map((data)=>{
                        let residualPaddingX = 0, residualPaddingY = 0, residualAdded = false
                        let targetPaddingX = 0, targetPaddingY = 0, targetAdded = false
                        let grossPaddingX = 0, grossPaddingY = 0, grossAdded = false

                        let residualPositionObj = { x: data.residual_impact[0], y: data.residual_likelhood[0] }
                        let targetPositionObj = { x: data.target_impact[0], y: data.target_likelhood[0] }
                        let grossPositionObj = { x: data.gross_impact[0], y: data.gross_likelhood[0] }
                        while (!residualAdded) {
                            let sameValue = positionList.some(el=>{return (el.x == residualPositionObj.x) && (el.y == residualPositionObj.y)})
                            // if no overlay, add the position in 
                            if (!sameValue) {
                                positionList.push(residualPositionObj)
                                residualAdded = true
                            // if overlay, move a padding
                            } else if (sameValue) {
                                if (residualPaddingX < 3) {
                                    residualPositionObj.x = residualPositionObj.x + 1
                                    residualPaddingX++
                                } else {
                                    residualPositionObj.x = (residualPositionObj.x)[0]
                                    residualPositionObj.y = residualPositionObj.y + 1
                                    residualPaddingX = 0
                                    residualPaddingY++
                                }
                            }
                        }

                        while (!targetAdded) {
                            let sameValue = positionList.some(el=>{return (el.x == targetPositionObj.x) && (el.y == targetPositionObj.y)})
                            if (!sameValue) {
                                positionList.push(targetPositionObj)
                                targetAdded = true
                            } else if (sameValue) {
                                if (targetPaddingX < 3) {
                                    targetPositionObj.x = targetPositionObj.x + 1
                                    targetPaddingX++
                                } else {
                                    targetPositionObj.x = (targetPositionObj.x)[0]
                                    targetPositionObj.y = targetPositionObj.y + 1
                                    targetPaddingX = 0
                                    targetPaddingY++
                                }
                            }
                        }

                        while (!grossAdded) {
                            let sameValue = positionList.some(el=>{return (el.x == grossPositionObj.x) && (el.y == grossPositionObj.y)})
                            if (!sameValue) {
                                positionList.push(grossPositionObj)
                                grossAdded = true
                            } else if (sameValue) {
                                if (grossPaddingX < 3) {
                                    grossPositionObj.x = grossPositionObj.x + 1
                                    grossPaddingX++
                                } else {
                                    grossPositionObj.x = (grossPositionObj.x)[0]
                                    grossPositionObj.y = grossPositionObj.y + 1
                                    grossPaddingX = 0
                                    grossPaddingY++
                                }
                            }
                        }
                        //console.log(positionList)
                        //console.log('paddingX: ' + paddingX + ' paddingY: ' + paddingY)
                        return (
                            <div>
                                <ResidualMark name={data.risk_name} side={65} PositionX={data.residual_impact[0]} PositionY={data.residual_likelhood[0]} paddingX= {residualPaddingX} paddingY={residualPaddingY}/>
                                <TargetMark name={data.risk_name} side={65} PositionX={data.target_impact[0]} PositionY={data.target_likelhood[0]} paddingX= {targetPaddingX} paddingY={targetPaddingY}/>
                                <GrossMark name={data.risk_name} side={65} PositionX={data.gross_impact[0]} PositionY={data.gross_likelhood[0]} paddingX= {grossPaddingX} paddingY={grossPaddingY}/>
                            </div>
                        )
                    })
                }
                <Typography variant='h6' style={{padding:'10px 0px 10px 25px'}}>Risk Rating for Key Risks</Typography>
                <HeatMap
                    xLabels={xLabels}
                    yLabels={yLabels}
                    xLabelsLocation={"bottom"}
                    height={65}
                    xLabelWidth={50}
                    data={this.props.map}
                    squares
                    //onClick={(x, y) => alert(`Clicked ${x}, ${y}`)}
                    cellStyle={(background, value, min, max, data, x, y) => ({
                        background: value == 1 ? setting.COLOR.GREEN : value==2 ? setting.COLOR.AMBER : setting.COLOR.RED,
                        fontSize: '11px'
                    })}
                    cellRender={value => value && ``}
                />
                <Typography style={{fontSize:'1rem', position:'absolute', transform:'rotate(-90deg) translateZ(1px)', top:'200px', left:'-90px'}}>Likelihood of Occurrance</Typography>
                <Typography style={{fontSize:'1rem', paddingLeft:'50px'}}>Magnitude of Impact</Typography>
            </CardContent>
        )
    }
}
export default (CustomizedHeatMap);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/heatmap.js